module.exports = __webpack_public_path__ + "prod_kquiwpdm/img/main-logo.23e076fe.png";